import React, { Fragment } from 'react';
import Validationtip from '../validationtip/Validationtip';
import Button from '../button/Button';
import { cloneDeep } from 'lodash';
import { ColumnConfig } from '../table/Table';
import { useDispatch } from 'react-redux';

interface GridCellWrapperProps {
  children: any;
  classes?: string;
  defaultKundeTableConfig?: ColumnConfig[];
  label?: any;
  lastSelectedColumnHeader?: number;
  layoutName?: string;
  name?: string;
  saveUserAnsicht?: () => void;
  setLastSelectedColumnHeader?: (value: number) => void;
  setTableConfig?: (tableConfig: ColumnConfig[]) => void;
  tableConfig?: ColumnConfig[];
  withColumnSortable?: boolean;
  withLabel?: boolean;
}

const GridCellWrapper = ({
  label,
  classes,
  children,
  withLabel = true,
  name,
  withColumnSortable,
  lastSelectedColumnHeader,
  setLastSelectedColumnHeader,
  tableConfig,
  setTableConfig,
  saveUserAnsicht,
}: GridCellWrapperProps) => {
  const dispatch = useDispatch();
  const conditionsOK = () => {
    return (
      withColumnSortable &&
      lastSelectedColumnHeader !== undefined &&
      lastSelectedColumnHeader !== null &&
      lastSelectedColumnHeader !== -1
    );
  };

  const onClickLeft = () => {
    if (
      lastSelectedColumnHeader &&
      tableConfig &&
      setTableConfig &&
      lastSelectedColumnHeader > 0
    ) {
      const tableConfigTmp = cloneDeep(tableConfig);
      tableConfigTmp[lastSelectedColumnHeader].id =
        tableConfigTmp[lastSelectedColumnHeader].id - 1;
      tableConfigTmp[lastSelectedColumnHeader - 1].id =
        tableConfigTmp[lastSelectedColumnHeader].id + 1;

      setTableConfig(
        tableConfigTmp.sort((configA, configB) =>
          configA.id > configB.id ? 1 : -1
        )
      );

      if (conditionsOK() && setLastSelectedColumnHeader) {
        setLastSelectedColumnHeader(lastSelectedColumnHeader - 1);
      }
    }
  };
  const onClickRight = () => {
    if (
      lastSelectedColumnHeader !== undefined &&
      lastSelectedColumnHeader !== null &&
      tableConfig &&
      setTableConfig &&
      lastSelectedColumnHeader < tableConfig.length - 1
    ) {
      const tableConfigTmp = cloneDeep(tableConfig);
      tableConfigTmp[lastSelectedColumnHeader].id =
        tableConfigTmp[lastSelectedColumnHeader].id + 1;
      tableConfigTmp[lastSelectedColumnHeader + 1].id =
        tableConfigTmp[lastSelectedColumnHeader].id - 1;

      setTableConfig(
        tableConfigTmp.sort((configA, configB) =>
          configA.id > configB.id ? 1 : -1
        )
      );
      if (conditionsOK() && setLastSelectedColumnHeader) {
        setLastSelectedColumnHeader(lastSelectedColumnHeader + 1);
      }
    }
  };

  const onClickLeftSave = () => {
    if (saveUserAnsicht && setLastSelectedColumnHeader) {
      dispatch(saveUserAnsicht());
      setLastSelectedColumnHeader(-1);
    }
  };

  return (
    <div className={'grid-cell-wrapper ' + classes}>
      {withLabel && (
        <Fragment>
          <div className='card-header noSelect'>
            <div className={'label-content'}>
              {' '}
              <Validationtip fieldName={name ?? ''}>{label} </Validationtip>
              {withColumnSortable &&
                lastSelectedColumnHeader !== undefined &&
                lastSelectedColumnHeader !== null &&
                lastSelectedColumnHeader !== -1 &&
                Array.isArray(tableConfig) &&
                tableConfig.length > 0 && (
                  <>
                    <Button
                      classes='arrow-button-to-left'
                      tooltip='nach links verschieben'
                      onClickHandler={onClickLeft}
                    >
                      <i className='fas fa-arrow-left' />
                    </Button>

                    <p>
                      {tableConfig &&
                        tableConfig[lastSelectedColumnHeader].columnName}
                    </p>
                    <Button
                      classes='arrow-button'
                      tooltip={'nach rechts verschieben'}
                      onClickHandler={onClickRight}
                    >
                      <i className='fas fa-arrow-right' />
                    </Button>
                    <Button
                      classes='save-button'
                      tooltip={'Speichern'}
                      onClickHandler={onClickLeftSave}
                    >
                      <i className='fas fa-save'></i>
                    </Button>
                  </>
                )}
            </div>

            <div className='color-corner' />
          </div>
        </Fragment>
      )}
      <div className='grid-cell-content'>{children}</div>
    </div>
  );
};
export default GridCellWrapper;
